import React from 'react'
import Navbar from './Navbar'
export default function Contact() {
    return (
        <div>
<Navbar/>
        </div>
    )
}
